import React from 'react'
import styled from 'styled-components'
import { Input } from '../../../../components/FormComponents'

const CoverImageFeedBackDiv = styled.div`
  text-align: center;
  padding: 15px 0;
`
const FeedBackHeading = styled.h3`
  color: #303030;
  font-family: 'Noto Sans';
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  margin: 8px 0%;
`
const FeedBackSubSubHeading = styled.p`
  color: #747474;
  font-family: 'Noto Sans';
  font-size: 12px;
  line-height: 160%;
  margin: 8px 0;
`
const FeedBackButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 20px 0;
`
const FeedBackButton = styled.button`
  width: 142px;
  height: 52px;
  padding: 16px 32px;
  border-radius: 100px;
  border: 2px solid #ededed;
  font-family: 'Noto Sans';
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  line-height: 0;
`
const FeedBackLikeButton = styled(FeedBackButton)`
  color: ${({ coverImageFeedback }) =>
    coverImageFeedback.feedback === 'Like' ? 'white' : '#f95555'};
  background-color: ${({ coverImageFeedback }) =>
    coverImageFeedback.feedback === 'Like' ? '#F95555' : 'white'};
`
const FeedBackDislikeButton = styled(FeedBackButton)`
  color: ${({ coverImageFeedback }) =>
    coverImageFeedback.feedback === 'Dislike' ? 'white' : '#9d9d9d'};
  background-color: ${({ coverImageFeedback }) =>
    coverImageFeedback.feedback === 'Dislike' ? '#7C7C7C' : 'white'};
`
const CoverImageDiv = styled.div`
  img {
    width: 70%;
  }
`
const WhyDislikeInput = styled.div`
  padding: 0 20px;
  @media screen and (max-width: 600px) {
    padding: 0;
  }
`

const AIGeneratedCoverImage = ({
  imageUrl,
  bookTitle = '',
  askForCoverImageFeedBack,
  coverImageFeedback,
  SetCoverImageFeedback,
  handleImageClick
}) => {
  return (
    <>
      <CoverImageFeedBackDiv>
        <CoverImageDiv onClick={handleImageClick}>
          <img src={imageUrl} alt={bookTitle} />
        </CoverImageDiv>
        {askForCoverImageFeedBack && (
          <>
            <FeedBackHeading>Do you like the Cover Design?</FeedBackHeading>
            <FeedBackSubSubHeading>
              Help us provide you better experience in future
            </FeedBackSubSubHeading>
            <FeedBackButtons>
              <FeedBackLikeButton
                coverImageFeedback={coverImageFeedback}
                type="button"
                onClick={() =>
                  SetCoverImageFeedback({ feedback: 'Like', message: '' })
                }
              >
                {coverImageFeedback.feedback === 'Like' ? '🤍' : '❤️'} Love it 
              </FeedBackLikeButton>
              <FeedBackDislikeButton
                coverImageFeedback={coverImageFeedback}
                type="button"
                onClick={() =>
                  SetCoverImageFeedback({ feedback: 'Dislike', message: '' })
                }
              >
                👎🏻 Dislike it 
              </FeedBackDislikeButton>
            </FeedBackButtons>
            {coverImageFeedback.feedback === 'Dislike' && (
              <WhyDislikeInput>
                <Input
                  asTextArea
                  placeholder="Write Your Feedback"
                  onChange={(e) =>
                    SetCoverImageFeedback({
                      feedback: 'Dislike',
                      message: e.target.value,
                    })
                  }
                  value={coverImageFeedback.message}
                  style={{
                    textAlign: 'left',
                  }}
                />
              </WhyDislikeInput>
            )}
          </>
        )}
      </CoverImageFeedBackDiv>
    </>
  )
}

export default AIGeneratedCoverImage
